module.exports = __webpack_public_path__ + "static/media/29ADMSPC30.9d8862bd.jpg";